(function () {
  'use strict';

  function updateGalleryCounter(root) {
    var counter = root.querySelector('[data-hyde-gallery-counter]');
    if (!counter) return;

    if (!window.matchMedia('(max-width: 768px)').matches) {
      counter.hidden = true;
      counter.textContent = '';
      return;
    }

    var thumbs = root.querySelectorAll('[data-product-thumb]');
    var total = thumbs.length;

    if (total <= 1) {
      counter.hidden = true;
      counter.textContent = '';
      return;
    }

    var activeIndex = 0;
    thumbs.forEach(function (btn, index) {
      if (btn.classList.contains('is-active')) {
        activeIndex = index;
      }
    });

    counter.textContent = activeIndex + 1 + ' / ' + total;
    counter.hidden = false;
  }

  function syncGalleryCounterFromHeroScroll(root) {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    var viewport = root.querySelector('[data-product-hero-viewport]');
    var track = root.querySelector('[data-product-hero-track]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('[data-product-hero-slide]');
    if (!slides.length) return;

    var scrollLeft = viewport.scrollLeft;
    var nearestIndex = 0;
    var nearestDistance = Infinity;

    slides.forEach(function (slide, index) {
      var distance = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    var counter = root.querySelector('[data-hyde-gallery-counter]');
    if (!counter || slides.length <= 1) return;

    counter.textContent = nearestIndex + 1 + ' / ' + slides.length;
    counter.hidden = false;
  }

  function updateDiscountBadge(root, variant) {
    var discountEl = root.querySelector('[data-product-discount]');
    if (!discountEl || !variant) return;

    if (variant.compare_at_price > variant.price && variant.compare_at_price > 0) {
      var percent = Math.round(
        ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
      );
      discountEl.textContent = percent + '% OFF';
      discountEl.hidden = false;
      discountEl.classList.remove('hyde-pdp__discount-badge--hidden');
      return;
    }

    discountEl.textContent = '';
    discountEl.hidden = true;
    discountEl.classList.add('hyde-pdp__discount-badge--hidden');
  }

  function bindGalleryCounter(root) {
    var viewport = root.querySelector('[data-product-hero-viewport]');
    if (!viewport || viewport.dataset.hydeCounterBound === 'true') return;
    viewport.dataset.hydeCounterBound = 'true';

    var scrollTicking = false;
    var lastScrollLeft = viewport.scrollLeft;

    viewport.addEventListener(
      'scroll',
      function () {
        if (viewport.scrollLeft === lastScrollLeft) return;
        lastScrollLeft = viewport.scrollLeft;

        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          scrollTicking = false;
          syncGalleryCounterFromHeroScroll(root);
        });
      },
      { passive: true }
    );
  }

  function openHydeQuickAdd(root) {
    var jsonEl = root.querySelector('[data-hyde-quick-add]');
    if (!jsonEl) return;

    try {
      var data = JSON.parse(jsonEl.textContent.trim());
      var metaEl = root.querySelector('[data-hyde-quick-add-upsells]');

      if (metaEl) {
        try {
          var meta = JSON.parse(metaEl.textContent.trim());
          if (meta.upsells && meta.upsells.length) {
            data.upsells = meta.upsells;
          }
          if (meta.upsell_heading) {
            data.upsell_heading = meta.upsell_heading;
          }
          if (meta.upsell_benefits) {
            data.upsell_benefits = meta.upsell_benefits;
          }
          if (meta.skip_label) {
            data.skip_label = meta.skip_label;
          }
        } catch (metaError) {
          console.error('Hyde quick add upsell meta parse error:', metaError);
        }
      }

      var variantInput = root.querySelector('[data-product-variant-id]');
      var variantId = variantInput ? variantInput.value : null;

      document.dispatchEvent(
        new CustomEvent('rabitat:quick-add:open', {
          detail: {
            data: data,
            variantId: variantId,
            options: {
              hideViewProduct: true,
              hideVariants: true,
              hideUpsells: true,
              postAddUpsell: true
            }
          }
        })
      );
    } catch (error) {
      console.error('Hyde quick add data parse error:', error);
    }
  }

  function bindQuickAdd(root) {
    if (document.querySelector('[data-buy2-combo-root]')) return;

    root.querySelectorAll('[data-hyde-quick-add-trigger]').forEach(function (trigger) {
      if (trigger.dataset.hydeQuickAddBound === 'true') return;
      trigger.dataset.hydeQuickAddBound = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (trigger.disabled) return;
        openHydeQuickAdd(root);
      });
    });
  }

  function bindStickyQuickAdd() {
    if (document.querySelector('[data-buy2-combo-root]')) return;

    document.querySelectorAll('[data-hyde-sticky-quick-add]').forEach(function (trigger) {
      if (trigger.dataset.hydeStickyQuickAddBound === 'true') return;
      trigger.dataset.hydeStickyQuickAddBound = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (trigger.disabled) return;

        var root = document.querySelector('[data-hyde-pdp]');
        if (root) openHydeQuickAdd(root);
      });
    });
  }

  function initHydePdp(root) {
    if (!root || !root.hasAttribute('data-hyde-pdp')) return;

    updateGalleryCounter(root);
    bindGalleryCounter(root);
    bindQuickAdd(root);

    root.addEventListener('click', function (event) {
      if (
        event.target.closest('[data-product-thumb]') ||
        event.target.closest('[data-product-hero-prev]') ||
        event.target.closest('[data-product-hero-next]')
      ) {
        window.requestAnimationFrame(function () {
          updateGalleryCounter(root);
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hyde-pdp]').forEach(initHydePdp);
    bindStickyQuickAdd();
  }

  document.addEventListener('rabitat:variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-hyde-pdp]').forEach(function (root) {
      updateDiscountBadge(root, variant);
      window.requestAnimationFrame(function () {
        updateGalleryCounter(root);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hyde-pdp]');
    if (root) initHydePdp(root);
    bindStickyQuickAdd();
  });

  window.HydePdp = window.HydePdp || {};
  window.HydePdp.openQuickAdd = openHydeQuickAdd;
})();
